import { active } from "@api/stores/active/path";
import { activeSubscriptionStats } from "@api/stores/activeSubscriptionStats/path";
import { costs } from "@api/stores/costs/path";
import { customerReports } from "@api/stores/customerReports/path";
import { customers } from "@api/stores/customers/path";
import { deactive } from "@api/stores/deactive/path";
import { employeeActivities } from "@api/stores/employeeActivities/path";
import { employeeCosts } from "@api/stores/employeeCosts/path";
import { employeeStats } from "@api/stores/employeeStats/path";
import { financial } from "@api/stores/financial/path";
import { measurementUnits } from "@api/stores/measurementUnits/path";
import { notifications } from "@api/stores/notifications/path";
import { productBatches } from "@api/stores/productBatches/path";
import { productCategories } from "@api/stores/productCategories/path";
import { productPrices } from "@api/stores/productPrices/path";
import { productReports } from "@api/stores/productReports/path";
import { products } from "@api/stores/products/path";
import { purchaseInvoiceItemReport } from "@api/stores/purchaseInvoiceItemReport/path";
import { purchaseInvoiceReport } from "@api/stores/purchaseInvoiceReport/path";
import { purchaseInvoiceReturns } from "@api/stores/purchaseInvoiceReturns/path";
import { purchaseInvoices } from "@api/stores/purchaseInvoices/path";
import { readStatus } from "@api/stores/readStatus/path";
import { salesInvoiceItemReport } from "@api/stores/salesInvoiceItemReport/path";
import { salesInvoiceReport } from "@api/stores/salesInvoiceReport/path";
import { salesInvoiceReturns } from "@api/stores/salesInvoiceReturns/path";
import { salesInvoices } from "@api/stores/salesInvoices/path";
import { storeStats } from "@api/stores/storeStats/path";
import { suppliers } from "@api/stores/suppliers/path";
import { users } from "@api/stores/users/path";
import { warehouses } from "@api/stores/warehouses/path";
import { apiPathFunc } from "@api/util/apiPathFunc";
import { warehouseCirculations } from "src/api/stores/warehouseCirculation/path";

import { setPassword } from "./setStoreUserPassword/path";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/`;
const pathById = `${pathBase}:storeId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const stores = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
  active,
  deactive,
  setPassword,
  warehouses,
  productCategories,
  measurementUnits,
  users,
  customers,
  suppliers,
  costs,
  employeeCosts,
  products,
  activeSubscriptionStats,
  salesInvoices,
  productPrices,
  productBatches,
  purchaseInvoices,
  salesInvoiceReturns,
  purchaseInvoiceReturns,
  salesInvoiceReport,
  salesInvoiceItemReport,
  purchaseInvoiceReport,
  purchaseInvoiceItemReport,
  warehouseCirculations,
  financial,
  employeeActivities,
  productReports,
  customerReports,
  storeStats,
  notifications,
  employeeStats,
  readStatus,
};
